import { Box, Typography, useTheme ,Stack,Button,IconButton} from "@mui/material";
import { GridColumns,
  GridCellParams,
  GridRowsProp,
  DataGrid,
  GridCellModesModel,
  GridCellModes} from "@mui/x-data-grid";
import { tokens } from "../../../theme";
import Header from "../../../components/global/Header";
import React, { useState, useEffect,useMemo } from 'react';
import NiceDate from "../../../components/global/NiceDate";
import { useDispatch, useSelector } from "react-redux";
import { getMessages } from "../../../slices/mqtt";
import DeleteIcon from '@mui/icons-material/Delete';
import LockIcon from '@mui/icons-material/Lock';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import BlockIcon from '@mui/icons-material/Block';
import NiceUser from "../../../components/global/NiceUser";
import CheckIcon from '@mui/icons-material/Check';

const Messages = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const dispatch = useDispatch();

  const messages = useSelector((state) => state.mqtt.messages);

  const [page, setPage] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(10);


  useEffect(() => {

    const search = {
      page,
      pageSize,
    }

    dispatch(getMessages({search}));

}, [page,pageSize]);



  const columns = [
    { 
      field: "id", 
      headerName: "ID" ,
      flex: 1
    },
    {
      field: "signId",
      headerName: "Sign",
      flex: 1,
    },
    {
      field: "message",
      headerName: "Message",
      flex: 1,
    },
    {
      field: "command",
      headerName: "Command",
      flex: 1,
    },
    {
      field: "value",
      headerName: "Value",
      flex: 1,
    },
    



    {
      field: "receivedAt",
      headerName: "Received",  
      flex: 1,
      renderCell: ({row: {receivedAt}}) => {

        return (
          <NiceDate>{receivedAt}</NiceDate>
        )
      }
    },    

  ];

  return (

    <Box m="20px">

      <Header title="Sign Messages" subtitle="List of messages" />

      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            borderBottom: "none",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >

          <DataGrid  experimentalFeatures={{newEditingApi: true }}
          
            rows={messages.list} 
            columns={columns} 
            pageSize={pageSize}
            page={messages.page}
            rowsPerPageOptions={[10, 25,50,100]}
            paginationMode="server"
            rowCount={messages.total}
            onPageChange={(newPage) => setPage(newPage)}
            onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
            
          />    

      </Box>
    </Box>
  );
};

export default Messages;
